import Locale from "../../../../vendor_core/core/src/utils/Locale";

/**
 * Every label of the history popup: [localization key, English fallback].
 * The fallback is shown while a locale has no translation for the key yet.
 */
const HISTORY_TEXTS = {
    title: ["gui_history", "HISTORY"],
    empty: ["ui_history_empty", "No history available"],
    // Round summary
    roundId: ["ui_history_round", "Round ID"],
    started: ["ui_history_start", "Started"],
    ended: ["ui_history_end", "Ended"],
    totalBet: ["ui_history_total_bet", "Total bet"],
    freeSpins: ["ui_history_free_spins", "Free spins"],
    freeSpinsCombo: ["ui_history_free_spins_combo", "Free spins combo"],
    totalWin: ["ui_history_total_win", "Total win"],
    baseSpinWin: ["ui_history_base_win", "Base spin win"],
    replaySpinWin: ["ui_history_replay", "Replay spin win"],
    freeSpinsWin: ["ui_history_free_spins_win", "Free spins win"],
    balanceBefore: ["ui_history_balance_before", "Balance before bet"],
    balanceAfterBet: ["ui_history_balance_after_bet", "Balance after bet"],
    balanceAfter: ["ui_history_balance_after", "Balance after round"],
    // Sections and grids
    baseSpin: ["ui_history_base", "Base spin"],
    replaySpin: ["ui_history_replay_spin", "Replay spin"],
    freeSpin: ["ui_history_free_spin", "Free spin"],
    startGrid: ["ui_history_start_grid", "Initial symbols"],
    cascade: ["ui_history_cascade", "Cascade"],
    finalGrid: ["ui_history_final_grid", "Final symbols"],
    previous: ["ui_history_previous", "Previous"],
    next: ["ui_history_next", "Next"],
    play: ["ui_history_play", "Play"],
    pause: ["ui_history_pause", "Pause"],
    // Wins tables
    wins: ["ui_history_wins", "Wins"],
    clusterId: ["ui_history_cluster_id", "Cluster ID"],
    cascadeId: ["ui_history_cascade_id", "Cascade ID"],
    symbol: ["ui_history_symbol", "Symbol"],
    size: ["ui_history_size", "Size"],
    win: ["win", "Win"],
    jackpotId: ["ui_history_jackpot_id", "Jackpot ID"],
    tier: ["ui_history_tier", "Tier"],
    jackpot: ["jackpot", "Jackpot"]
} as const;

export type HistoryText = keyof typeof HISTORY_TEXTS;

// Uses the translation when the key exists, otherwise the English fallback
export function historyText(name: HistoryText): string {
    const [key, fallback] = HISTORY_TEXTS[name];
    const text = Locale.getString(key);
    return Locale.isTranslated(text, key) ? text : fallback;
}

// Free spins feature name (Blue, Red, Yellow). Translated for display only, without a fallback.
export function comboText(name: string): string {
    return Locale.getString(`ui_history_combo_${name.toLowerCase()}`);
}
